__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-14-1784037856-stable-dev/";